import { Controller } from "@hotwired/stimulus"

// This controller accepts events from the other Stimulus controllers to update the selection in the form.
export default class extends Controller {
  static get values() {
    return {
      url: String,
      name: String,
      previewUrl: String,
      domainsListId: Number,
      domains: { type: Array, default: [] },
      selectedDomains: { type: Object, default: {} },
    }
  }

  static get targets() {
    return [
      "domainsInput", "nameInput", "selectionTitle", "selectionDescription", "emailsPerDomainInput",
      "rolesInput", "departmentsSelect", "previewFrame"
    ]
  }

  updateSelection({ detail: { selectedDomains } }) {
    this.selectedDomainsValue = selectedDomains
    let numberOfDomains = Object.keys(selectedDomains).length
    let companyNames = Object.values(selectedDomains).slice(0, 5)

    if (numberOfDomains > 0) {
      this.selectionTitleTarget.innerText = i18n.t("js.back.sidepanel.bulk_search_form.title", { count: numberOfDomains, number: i18n.numberToDelimited(numberOfDomains) })
      let bulkName = i18n.t("js.back.sidepanel.bulk_search_form.description", { count: numberOfDomains - companyNames.length, number: i18n.numberToDelimited(numberOfDomains - 5), company_names: companyNames.join(", ") })
      this.selectionDescriptionTarget.innerText = bulkName
      this.nameInputTarget.value = bulkName
      this.domainsInputTarget.value = Object.keys(selectedDomains).join("\n")
    } else {
      this.selectionTitleTarget.innerText = i18n.t("js.back.sidepanel.bulk_search_form.title", { count: this.domainsValue.length, number: i18n.numberToDelimited(this.domainsValue.length) })
      this.selectionDescriptionTarget.innerText = this.nameValue
      this.nameInputTarget.value = this.nameValue
      this.domainsInputTarget.value = this.domainsValue.join("\n")
    }

    this.updatePreview()
  }

  updatePreview() {
    let numberOfDomains = Object.keys(this.selectedDomainsValue).length
    let newPreviewUrl = new URL(this.previewUrlValue, window.location.origin)
    let roles = this.rolesInputTargets.filter((input) => input.checked).map((input) => input.value)[0]
    let departments = Array.from(this.departmentsSelectTarget.selectedOptions).map((option) => option.value).join(",")

    if (this.hasEmailsPerDomainInputTarget) {
      newPreviewUrl.searchParams.append("emails_per_domain", this.emailsPerDomainInputTarget.value)
    }

    if (roles === "all") {
      newPreviewUrl.searchParams.append("roles", "personal,generic")
    } else {
      newPreviewUrl.searchParams.append("roles", roles)
    }

    if (departments !== "") {
      newPreviewUrl.searchParams.append("departments", departments)
    }

    if (numberOfDomains > 0) {
      newPreviewUrl.searchParams.append("domains", Object.keys(this.selectedDomainsValue).join(","))
    } else if (this.hasDomainsListIdValue) {
      newPreviewUrl.searchParams.append("domains_list_id", this.domainsListIdValue)
    } else {
      newPreviewUrl.searchParams.append("domains", this.domainsValue.join(","))
    }

    this.previewFrameTarget.src = newPreviewUrl
  }
}
